<div class="content" *ngIf="isSuperAdmin">
  <div class="container-fluid">
    <div class="page-title">
      <h1>API Management</h1>
    </div>
    <div class="page-filter clearfix two-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list device-name">
            <div class="filter-content">
              <p-select [options]="CompanyOptions" [(ngModel)]="FilterParam.RegionId" (onChange)="FilterChange($event)" [style]="{'width':'100%'}" placeholder="Company"></p-select>
            </div>
          </div>
        </div>
        <div class="filter search float-right">
          <div class="button">
            <input type="text" pInputText placeholder="Search" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <p-table class="deviceTable pageAllOptions" #dt [columns]="deviceSettingData_cols" [value]="apiSettingData" [rows]="10" [paginator]="true"
               [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true" sortField="Account">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td style="width:200px" class="col-nowrap">{{rowData.RegionName}}</td>
            <!-- <td style="width:150px" class="col-nowrap">{{rowData.apiKeyId}}</td> -->
            <td style="width:220px" class="col-nowrap">
              <a routerLink="/management/api/api-detail/{{rowData.HashApiKeyId}}">{{rowData.name}}</a>
            </td>
            <td style="width:350px;white-space: pre-wrap;word-wrap: break-word;" class="col-nowrap">{{rowData.apiKey}}</td>
            <td style="width: 250px" class="col-nowrap">
              <a routerLink="/management/account/account-detail/{{rowData.HashAcode}}">{{rowData.Account}}</a>
            </td>
            <td style="width: 150px" class="col-nowrap">{{(rowData.CreateTime != null) ? ((rowData.CreateTime) | date: 'yyyy/MM/dd') : ''}}</td>
            <td style="width: 150px" class="col-nowrap">{{(rowData.ExpiredTime != null) ? ((rowData.ExpiredTime) | date: 'yyyy/MM/dd') : ''}}</td>
            <td style="width:100px">
              <div *ngIf="!rowData.expired else expiredTag">
                <span *ngIf="rowData.status === true">Enable</span>
                <span *ngIf="rowData.status === false">Disable</span>
              </div>
              <ng-template #expiredTag>
                <span>Expired</span>
              </ng-template>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="deviceSettingData_cols.length">
              <div translate class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    
    <div class="user apiCalls">
      <div class="page-filter clearfix border-b-radius-none" style="margin: 0 0 0 0">
        <div class="row">
          <div class="col-md-12" style="margin: 0 !important;">
            <h5>Monthly API Calls</h5>
          </div>
        </div>
      </div>
      <div class="content-info evnets">
        <div class="activityData border-t-radius-none">
          <p-table class="deviceTable pageAllOptions" [columns]="total_cols"
            [value]="monthlyAPICallsData" [scrollable]="true" scrollHeight="600px">
            <ng-template pTemplate="colgroup" let-columns>
              <colgroup>
                <col *ngFor="let col of columns" [style.width.px]="col.width || 50">
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [ngClass]="col.class">
                  {{col.header}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [ngClass]="{'accumulated': rowData.type === 'Accumulated Calls'}">
                <td *ngFor="let col of columns" [ngClass]="col.class">
                  <div>
                    <div class="value">
                      {{(rowData.type !== 'Total' && rowData.type !== 'Accumulated Calls') ? rowData[col.field].value :
                      rowData[col.field]}}
                    </div>
                    <div class="percentage" *ngIf="rowData.type !== 'Total' && rowData.type !== 'Accumulated Calls'">
                      {{(rowData.type !== 'Total' && rowData.type !== 'Accumulated Calls') ? rowData[col.field].PCT :
                      rowData[col.field]}} %</div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div>
          <div class="chart" style="background-color: #ffffff;">
            <p-chart type="bar" id="capture8" [data]="chart7" height="250" [options]='chartOption'></p-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<p-toast [style]="{marginTop: '70px'}"></p-toast>
